export default __webpack_public_path__ + "static/media/480_business02-es-mobile.c836b50d.png";